
  (function() {
     var loadScript = function(url, callback){
        var jQ;
        jQ = document.createElement('script');
        jQ.type = 'text/javascript';
        jQ.onload = jQ.onreadystatechange = callback;
        jQ.src = url;
        document.body.appendChild(jQ);
  };

  var customScript = function($) {
        $(function(){
            var ERROR_CLASS = 'required-error';
          	var form = $('form[action^="/cart"]');
            var checkoutButton = form.find('[name="checkout"], [name="goto_pp"], [name="goto_gc"]');
          	checkoutButton.on('click.requiredApp', {}, function(event) {
              	var visibleForm = $(event.target).parents('form[action^="/cart"]');
              	var input = visibleForm.find('.required-id-1672');
              	if (!input.val()) {
              		event.preventDefault();
                    event.stopImmediatePropagation();
                  	window.alert(input.attr('data-required-message'));
                  	input.parent().addClass(ERROR_CLASS);
                    input.parent().focus();
                  	input.on('input.requiredApp', {element: input.parent()}, function(e) {
                    	e.data.element.removeClass(ERROR_CLASS)
                  	})
              	}
          	})
        })
  };

  if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.7)) {
        loadScript('{{"jquery1124.min.js" | asset_url}}', function(){
        customScript(jQuery.noConflict(true));
      });
  } else {
      customScript(jQuery);
  }
})()
